import { computed, type ComputedRef } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'

interface UseButtonFlipup {
  disabled: ComputedRef<boolean>
  doFlipUp: Function
}

//------------------------------------------------
export function useButtonFlipup(): UseButtonFlipup {
  const samudkoyStore = useSamudkoyStore()

  const disabled = computed(() => !samudkoyStore.hasPageNext)

  function doFlipUp() {
    samudkoyStore.translateOff()
    samudkoyStore.flipUp()
  }

  return {
    disabled,
    doFlipUp,
  }
}

//------------------------------------------------
export function useButtonFlipupMock(): UseButtonFlipup {
  const disabled = computed(() => false)

  function doFlipUp() {
    console.debug('doFlipUp()')
  }

  return {
    disabled,
    doFlipUp,
  }
}
